export enum EnumTipoCaudal {
  g3 = 1,
  g6,
  g10,
  g25,
  g40,
  g65,
  g100,
  g160,
  g250
}
